package com.ervasstudio.tracoemovimento.pages.sobre

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateX
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.CSSNumeric
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s


@Composable
fun TeamCarousel(
    members: List<TeamMember>,
    visibleCount: Int = 5,
    autoPlayInterval: Long = 3000L,
    isTop: Boolean = true,
    isMobile: Boolean
) {
    // O limite máximo de passos é o total de membros menos os visíveis
    val maxStep = (members.size - visibleCount).coerceAtLeast(0)

    // Se for o carrossel de baixo (isTop == false), começa no último passo
    var step by remember(maxStep, isTop) {
        mutableStateOf(if (isTop) 0 else maxStep)
    }

    // Controla a direção da animação: true = avançando, false = voltando
    var movingForward by remember(isTop) { mutableStateOf(isTop) }
    var paused by remember { mutableStateOf(false) }

    // Animação contínua (vai até o final e volta)
    LaunchedEffect(paused, maxStep, isTop) {
        if (!paused && maxStep > 0) {
            while (true) {
                delay(autoPlayInterval)

                if (movingForward) {
                    if (step < maxStep) {
                        step++
                    } else {
                        // Chegou ao fim, inverte para voltar
                        movingForward = false
                        step--
                    }
                } else {
                    if (step > 0) {
                        step--
                    } else {
                        // Chegou ao início, inverte para avançar
                        movingForward = true
                        step++
                    }
                }
            }
        }
    }

    Column(
        modifier = Modifier.fillMaxWidth().margin(top = if (isTop) 5.px else 4.cssRem),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .position(Position.Relative)
                .padding(leftRight = 20.px)
        ) {

            // Track Container com overflow oculto
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .overflow(Overflow.Hidden)
            ) {
                Row(
                    modifier = Modifier
                        .gap(12.px)
                        .styleModifier {
                            property("transform", "translateX(calc(-${step} * (100% / $visibleCount + 12px * (1 - 1 / $visibleCount))))")
                            property("transition", "transform 0.6s cubic-bezier(0.25, 1, 0.5, 1)")
                        }
                        .onMouseEnter { paused = true }
                        .onMouseLeave { paused = false }
                ) {
                    members.forEach { member ->
                        Box(
                            modifier = Modifier
                                .classNames("team-card")
                                .flexShrink(0)
                                .styleModifier {
                                    property("width", "calc(100% / $visibleCount - (12px * ($visibleCount - 1) / $visibleCount))")
                                }
                        ) {
                            // Imagem
                            Image(
                                src = member.imageSrc,
                                modifier = Modifier
                                    .fillMaxSize()
                                    .objectFit(ObjectFit.Contain)
                            )

                            // Overlay com nome e cargo
                            Column(
                                verticalArrangement = Arrangement.Bottom,
                                modifier = Modifier.classNames("team-overlay")
                            ) {
                                SpanText(
                                    text = member.name,
                                    modifier = Modifier
                                        .fontFamily("GothamBlack")
                                        .fontSize(14.px)
                                        .fontWeight(FontWeight.Medium)
                                        .color(Colors.White)
                                )
                                SpanText(
                                    text = member.role,
                                    modifier = Modifier
                                        .fontFamily("Gotham")
                                        .fontSize(12.px)
                                        .color(Colors.White.copyf(alpha = 0.72f))
                                        .margin(top = 3.px)
                                )
                            }
                        }
                    }
                }
            }

            // Botão anterior (Retrocede um passo)
            if (step > 0) {
                CarouselNavBtn(
                    icon = "‹",
                    modifier = Modifier.left(5.px)
                ) {
                    step--
                    movingForward = false // Se o usuário interagir, ajusta a direção do auto-play
                }
            }

            // Botão próximo (Avança um passo)
            if (step < maxStep) {
                CarouselNavBtn(
                    icon = "›",
                    modifier = Modifier.right(5.px)
                ) {
                    step++
                    movingForward = true // Se o usuário interagir, ajusta a direção do auto-play
                }
            }
        }

        // Indicadores (Dots)
        if (maxStep > 0) {
            Row(
                horizontalArrangement = Arrangement.Center,
                modifier = Modifier.margin(top = if (isMobile) 10.px else 20.px).gap(6.px)
            ) {
                (0..maxStep).forEach { i ->
                    Box(
                        modifier = Modifier
                            .height(6.px)
                            .width(if (i == step) 18.px else 6.px)
                            .borderRadius(3.px)
                            .backgroundColor(if (i == step) Colors.Black else Colors.LightGray)
                            .styleModifier {
                                property("transition", "all 0.25s ease")
                            }
                            .cursor(Cursor.Pointer)
                            .onClick {
                                movingForward = i > step
                                step = i
                            }
                    )
                }
            }
        }
    }
}

@Composable
private fun CarouselNavBtn(
    icon: String,
    modifier: Modifier = Modifier,
    onClick: () -> Unit
) {
    Box(
        contentAlignment = Alignment.Center,
        modifier = Modifier
            .position(Position.Absolute)
            .top(50.percent)
            .translateY((-50).percent)
            .size(40.px) // Ligeiramente maior para clique mais fácil
            .borderRadius(50.percent)
            .backgroundColor(Colors.White)
            .border(1.px, LineStyle.Solid, Colors.LightGray)
            .cursor(Cursor.Pointer)
            .zIndex(10)
            .onClick { onClick() }
            .then(modifier)
    ) {
        SpanText(
            text = icon,
            modifier = Modifier
                .fontSize(24.px)
                .color(Colors.Black)
                .styleModifier {
                    property("line-height", "1")
                }
        )
    }
}

